import script from "./report.vue?vue&type=script&setup=true&lang=js"
export * from "./report.vue?vue&type=script&setup=true&lang=js"

import "./report.vue?vue&type=style&index=0&id=b4be1eb8&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2302593107/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4be1eb8"]])

export default __exports__